import { useEffect, useState } from "react";

export const MOBILE_VIEWPORT_MEDIA_QUERY = "(max-width: 991.98px)";

export const isMobileViewport = () =>
	window.mobile || window.matchMedia(MOBILE_VIEWPORT_MEDIA_QUERY).matches;

const useIsMobileViewport = () => {
	const [isMobile, setIsMobile] = useState(isMobileViewport);

	useEffect(() => {
		if (window.mobile) {
			return;
		}

		const mediaQueryList = window.matchMedia(MOBILE_VIEWPORT_MEDIA_QUERY);
		const updateIsMobile = () => {
			setIsMobile(isMobileViewport());
		};

		updateIsMobile();
		mediaQueryList.addEventListener("change", updateIsMobile);

		return () => {
			mediaQueryList.removeEventListener("change", updateIsMobile);
		};
	}, []);

	return isMobile;
};

export default useIsMobileViewport;
